import React from 'react';

import { ActionTabs } from '../../../../helpers/uiComponents/ActionTabs';
import { InputRow } from '../../../../helpers/uiComponents/InputRow';
import AccordianTitle from '../../../../helpers/uiComponents/Accordian';

import { hideMessage, showMessage } from '../../../../helpers/uiFunctions/uiActions';
import { addClient, saveSiteSettings } from '../../../../data/serviceClients';

export class WebsiteInfo extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
		}
		this.save = this.save.bind(this);
		this.handleUpdate = this.handleUpdate.bind(this);
	}
	handleUpdate(e) {
		var key = e.target.name;
		var value = e.target.value;
		var subArr = null;

		if (key.includes(".")) {
			subArr = key.split('.')[0];
			key = key.split('.')[1];
		}

		var type = e.target.type;
		if (type === "checkbox") {
			value = e.target.checked
		}

		var updateClient = this.props.updateClient        
        updateClient(key, value, subArr);
	}
    save() {
		showMessage("Saving Website Information...");		
        var client = this.props.currentClient;
		delete client.transactions;
        saveSiteSettings(client.clientCode, client.sites[0]).then(() => {
            addClient(this.props.currentClient).then(data => {
                hideMessage(data.success);
            });
        });
	}

	render() {
		const currentClient = this.props.currentClient;
        var website = currentClient.sites[0];
		const roles = this.props.roles;

		return (
			<div className="input-group">
				<AccordianTitle title={"Website Information"} />
				<div className="accordian-body">
					<ActionTabs
						handleSave={() => this.save("save", "website")}
						id={"website"}
					/>
					<div id="website-inputs" className="inputs">
						{(website) && (
							<React.Fragment>
								<input type="hidden" name="id" value={website.id} hidden="hidden" />
								<input type="hidden" name="clientCode" value={website.clientCode} hidden="hidden" />
								<input type="hidden" name="siteCode" value={website.siteCode} hidden="hidden" />
								<input type="hidden" name="instance" value={website.instance} hidden="hidden" />
								

								<h5>General</h5>
								<InputRow onChange={this.handleUpdate} label="Site Name" type="text" value={website.name} property="sites.name" description="This field is used for site business name sync and SEO" />
								<InputRow onChange={this.handleUpdate} label="URL" type="text" value={website.url} property="sites.url" />
								<InputRow onChange={this.handleUpdate} label="Platform" type="text" value={website.type} property="sites.type" />
								<InputRow onChange={this.handleUpdate} label="Go Live Date" type="date" value={website.goLive} property="sites.goLive" />
								<InputRow onChange={this.handleUpdate} label="Service Renewal Date" type="date" value={website.termRenewal} property="sites.termRenewal" />
								<InputRow onChange={this.handleUpdate} label="Service Termination Date" type="date" value={website.cancelDate} property="sites.cancelDate" />
								
								<h5>Settings</h5>
								<InputRow onChange={this.handleUpdate} label="Reply To Email" type="text" value={website.replyToEmail} property="sites.replyToEmail" description="From address used by the SendGrid to send Promo or Email Campaign events to the Customer." />
								<InputRow onChange={this.handleUpdate} label="Admin Email" type="text" value={website.adminEmail} property="sites.adminEmail" />
								<InputRow onChange={this.handleUpdate} label="Require Price" type="checkbox" value={website.requirePrice} property="sites.requirePrice" />
								<InputRow onChange={this.handleUpdate} label="Require Inventory" type="checkbox" value={website.requireInventory} property="sites.requireInventory" />
								<InputRow onChange={this.handleUpdate} label="MWP Connection Key" type="text" value={website.mwpKey} property="sites.mwpKey" />
								

								<h5>Tracking Codes & IDs</h5>
								<em>If GTM needs updated please notify Ross Callahan, Jason Dreibelbis, or Greg Lehr</em>
								{(roles.includes("trackingCodes")) ? (
									<React.Fragment>
										<InputRow onChange={this.handleUpdate} label="Google Tag Manager - Tag ID" type="text" value={website.gtmId} property="sites.gtmId" />
									</React.Fragment>
								) : (
									<React.Fragment>
										<InputRow label="Google Tag Manager - Tag ID" type="text" value={website.gtmId} property="sites.gtmId" disabled />
									</React.Fragment>
								)}
								

								<h5>Hosting</h5>
								<InputRow onChange={this.handleUpdate} label="Registrar" type="text" value={website.registrar} property="sites.registrar" />
								<InputRow onChange={this.handleUpdate} label="DNS" type="text" value={website.dns} property="sites.dns" />
								<InputRow onChange={this.handleUpdate} label="Host Service" type="text" value={website.host} property="sites.host" />
								

								<h5>Domain Info</h5>
								<InputRow onChange={this.handleUpdate} label="Client Owns Domain" type="checkbox" value={website.clientOwnsDomain} property="sites.clientOwnsDomain" />
								<InputRow onChange={this.handleUpdate} label="Client Pays Domain" type="checkbox" value={website.clientPaysDomain} property="sites.clientPaysDomain" />
								<InputRow onChange={this.handleUpdate} label="Client Owns Site" type="checkbox" value={website.clientOwnsSite} property="sites.clientOwnsSite" />
								<InputRow onChange={this.handleUpdate} label="Client Pays Site" type="checkbox" value={website.clientPaysSite} property="sites.clientPaysSite" />
								
							</React.Fragment>
						)}
					</div>
				</div>
			</div>
		)
	}

}


// WEBPACK FOOTER //
// ./src/component_client/components/ClientProfile/ProfileComponents/WebsiteInformation.js